import { createFileRoute } from '@tanstack/react-router';
import { ForeignVendorEditSheet } from '@/pages/foreign-vendors/edit-sheet';

export const Route = createFileRoute(
  '/admin/_layout/foreign-vendors/_layout/edit/$id'
)({
  component: ForeignVendorEditRoute,
});

function ForeignVendorEditRoute() {
  const { id } = Route.useParams();

  return <ForeignVendorEditSheet id={id} />;
}
